import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ArianeeBrandsListPage } from './arianee-brands-list.page';
import { CommonComponentsModule, PipeModule, ProductViewModule } from '@arianeeprivate/wallet-shared-components';
import { AskForBrandDialogComponent } from './components/ask-for-brand-dialog/ask-for-brand-dialog.component';
import { AskForBrandFormComponent } from './components/ask-for-brand-form/ask-for-brand-form.component';
import { AskForBrandSuccessComponent } from './components/ask-for-brand-success/ask-for-brand-success.component';

const routes: Routes = [
  {
    path: '',
    component: ArianeeBrandsListPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipeModule,
    TranslateModule,
    CommonComponentsModule,
    ProductViewModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ArianeeBrandsListPage, AskForBrandDialogComponent, AskForBrandFormComponent, AskForBrandSuccessComponent],
  entryComponents: [AskForBrandDialogComponent, AskForBrandFormComponent, AskForBrandSuccessComponent]
})
export class ArianeeBrandsListModule {}
